import React from 'react';
import FullPageSection from './FullPageSection';
import './ServicesSection.css';

const ServicesSection = () => {
    const services = [
        {
            title: 'Branding & Rebranding',
            description: 'Criamos identidades visuais completas que comunicam a essência da sua marca de forma clara e memorável.',
            benefits: ['Estratégia de marca', 'Identidade visual', 'Manual de marca', 'Naming'],
        },
        {
            title: 'Web Design & UI/UX',
            description: 'Desenhamos websites e interfaces digitais que combinam estética moderna com experiência de utilizador intuitiva.',
            benefits: ['Design responsivo', 'Prototipagem', 'UI/UX Design', 'Landing pages'],
        },
        {
            title: 'Identidade Visual',
            description: 'Desenvolvemos todos os elementos visuais necessários para uma comunicação consistente da sua marca.',
            benefits: ['Logótipos', 'Papelaria', 'Templates', 'Guidelines'],
        },
        {
            title: 'Packaging & Editorial',
            description: 'Criamos embalagens que se destacam nas prateleiras e publicações que captam a atenção.',
            benefits: ['Design de embalagens', 'Brochuras', 'Catálogos', 'Revistas'],
        },
        {
            title: 'Comunicação Digital',
            description: 'Materiais de comunicação digital para redes sociais, campanhas e apresentações corporativas.',
            benefits: ['Social media', 'Email marketing', 'Apresentações', 'Banners digitais'],
        },
        {
            title: 'Consultoria de Design',
            description: 'Apoio estratégico para decisões de design e desenvolvimento da presença visual da sua marca.',
            benefits: ['Auditoria de marca', 'Direção criativa', 'Estratégia visual', 'Workshops'],
        },
    ];

    return (
        <FullPageSection id="services" className="services-section">
            <div className="services-container">
                <div className="services-header">
                    <span className="section-label">Serviços</span>
                    <h2 className="section-title">
                        O que<br />
                        Fazemos
                    </h2>
                    <p className="section-description">
                        Soluções completas de design para empresas que procuram uma presença visual forte
                    </p>
                </div>

                <div className="services-grid">
                    {services.map((service, index) => (
                        <div key={index} className="service-card">
                            <h3 className="service-title">{service.title}</h3>
                            <p className="service-description">{service.description}</p>
                            <ul className="service-benefits">
                                {service.benefits.map((benefit, idx) => (
                                    <li key={idx}>{benefit}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </FullPageSection>
    );
};

export default ServicesSection;
